const Main = () => import('../../pages/main')
const UserCourse = () => import('../../pages/Course')
const Homework = () => import('../../pages/Course/Homework')
const HomeworkList = () => import('../../pages/Course/Homework/HomeworkList')
// const JobManagement = () => import('../../pages/Course/JobManagement')
const CourseStudy = () => import('../../pages/Course/CourseStudy.vue')

export default [{
	path: '/course',
	component: Main,
	meta: {
		requiresAuth: true,
		hidden: false,
		title: '我的课程',
		icon: 'icon-nav icon-nav-course',
		sideNav: true
	},
	children: [
		{
			name: 'userCourse',
			path: 'userCourse',
			component: UserCourse,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '视频课程',
			}
		},
		{
			name: 'homework',
			path: 'homework',
			component: Homework,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '作业填写',
			}
		},
		{
			name: 'homework-list',
			path: 'homework-list',
			component: HomeworkList,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '作业管理',
			}
		},
	]
},
{
	name: 'courseStudy',
	path: '/courseStudy/:id/:videoTypeId/:type/:videoPer',
	component: CourseStudy,
	meta: {
		requiresAuth: true
	}
}]
